
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"52","height":"52","rx":"26","fill":"#F0F4FA"}}),_c('path',{attrs:{"d":"M24.97 17.068l-2.343 4.964-5.244.799c-.94.142-1.317 1.354-.635 2.047l3.793 3.862-.897 5.456c-.161.986.833 1.725 1.666 1.263L26 32.883l4.69 2.576c.833.458 1.827-.277 1.666-1.263l-.897-5.456 3.793-3.862c.682-.694.305-1.905-.635-2.047l-5.243-.799-2.344-4.964a1.128 1.128 0 00-2.06 0z","fill":"#525F7F"}})])
          )
        }
      }
    